import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

export default class NewEventNotification extends Notification {
  icon() {
    return 'fas fa-calendar-plus';
  }

  href() {
    const data = this.attrs.notification.content();
    return data.discussionId ? app.route('discussion', { id: data.discussionId }) : '#';
  }

  content() {
    const data = this.attrs.notification.content();
    return app.translator.trans('florcarioca-rsvp.forum.notifications.new_event_text', {
      event_title: data.eventTitle,
    });
  }

  excerpt() {
    const data = this.attrs.notification.content();
    if (!data.eventDate) return null;
    const from = app.translator.trans('florcarioca-rsvp.forum.notifications.date_from');
    const start = dayjs(data.eventDate).format('DD/MM/YYYY HH:mm');
    if (data.eventEndDate) {
      const to = app.translator.trans('florcarioca-rsvp.forum.notifications.date_to');
      const end = dayjs(data.eventEndDate).format('DD/MM/YYYY HH:mm');
      return `📅 ${from} ${start} ${to} ${end}`;
    }
    return `📅 ${from} ${start}`;
  }
}
